export const setupCheckboxListener = (targetElement: Element, onNextStep: () => void): (() => void) => {
  let hasTriggered = false;

  const checkForCheckedCheckbox = () => {
    if (hasTriggered) return false;

    const checkboxes = targetElement.querySelectorAll('input[type="checkbox"]');
    for (const checkbox of Array.from(checkboxes)) {
      if (checkbox.hasAttribute('checked')) {
        hasTriggered = true;
        onNextStep();
        return true;
      }
    }
    return false;
  };

  checkForCheckedCheckbox();

  const attributeObserver = new MutationObserver((mutations) => {
    if (hasTriggered) return;

    for (const mutation of mutations) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'checked') {
        const target = mutation.target as HTMLInputElement;

        if (target.tagName === 'INPUT' && target.type === 'checkbox' && target.hasAttribute('checked')) {
          hasTriggered = true;
          onNextStep();
          break;
        }
      }
    }
  });

  attributeObserver.observe(targetElement, {
    attributes: true,
    attributeFilter: ['checked'],
    subtree: true,
  });

  const childObserver = new MutationObserver(() => {
    if (!hasTriggered) {
      checkForCheckedCheckbox();
    }
  });

  childObserver.observe(targetElement, {
    childList: true,
    subtree: true,
  });

  return () => {
    attributeObserver.disconnect();
    childObserver.disconnect();
  };
};
